import LanguageSwitcher from './LanguageSwitcher';

const langSwitch = new LanguageSwitcher();
langSwitch.init();
